<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="1000px"
      title="商户审核驳回的常见解决方案"
      center
      @close="$emit('update:visible', dialogVisible)">
      <div class="dialog-content-view">
        <el-table
        border
        :data="tipsList">
        <el-table-column
          type="index"
          label=" "
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="returnReson"
          label="审核退回原因"
          width="200">
        </el-table-column>
        <el-table-column
          prop="solution"
          label="解决方案"
          min-width="180">
        </el-table-column>
      </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'reviewReturnTipsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: this.visible,
      tipsList: [
        {
          returnReson: '身份证过期',
          solution: '身份证已超过有效期。按照要求：请提供身份证正面和（户口本、驾驶证、社保卡之一）合照以及本人手持身份证照片，补充资料，重新提交'
        },
        {
          returnReson: '三四要素鉴权结果： 鉴权失败',
          solution: '三要素校验指：姓名、身份证号、银行卡号均为同一人。请商户核实银行卡和身份证是否是同一人。备注：如已核实为同一人，极少数非主流银行卡，可能校验不通过，可联系乐刷运营说明审核。'
        },
        {
          returnReson: '地址不详细',
          solution: '地址按照**路**号填写；区后地址填写，不得少于5个字'
        },
        {
          returnReson: '缺少银行卡照片',
          solution: '银行卡正面照片为必传。请补充银行卡照片后重新提交'
        },
        {
          returnReson: '身份证与姓名不一致',
          solution: '商户首次填写信息错误，姓名、开户名或者身份证号码填写错误，导致校验不通过。备注：如已核实无误，可重新提交审核。'
        },
        {
          returnReson: '请提供清晰的银行卡正面照片',
          solution: '提供的银行卡照片不清晰，无法核对照片上卡号是否与填写卡号一致。请重新补充清晰的银行卡正面照片后提交。'
        },
        {
          returnReson: '请提供门头照，收银台，店内照',
          solution: '门头照，收银台，店内照为商户进件必传项，不得缺失。'
        },
        {
          returnReson: '卡号不一致',
          solution: '填写的银行卡账号，与银行卡照片的卡号不一致。请修改确认填写卡号与银行卡照片一致，重新提交。'
        },
        {
          returnReson: '身份证禁止截图',
          solution: '必传照片必须为真实照片，严禁截图，PS，带有水印和遮挡。请提交真实身份证照片，重新提交。'
        },
        {
          returnReson: '身份证禁止从电脑拍照',
          solution: '必传照片必须为真实照片，严禁截图，PS，带有水印和遮挡。请提交真实身份证照片，重新提交。'
        },
        {
          returnReson: '请重新提供身份证照片，需要露出四角',
          solution: '身份证正反面照片，需要露出四角。请重新补充后提交。'
        },
        {
          returnReson: '三合照模糊',
          solution: '必传照片必须为真实照片，严禁截图，PS，带有水印和遮挡。请提交拍摄真实照片，重新提交。'
        },
        {
          returnReson: '身份证号与身份证照片不一致，请重新上传',
          solution: '填写的身份证号与提交的身份证照片不一致。请重新修改，确认一致后提交。'
        },
        {
          returnReson: '法人姓名错误，必须与营业执照姓名一致',
          solution: '填写的法人姓名有误，必须与营业执照照片上的法人姓名一致'
        },
        {
          returnReson: '门头照不符合',
          solution: '门头照要显示出门店招牌名称'
        },
        {
          returnReson: '商户名称不够五个字',
          solution: '商户名称不得少于5个字，请补充后重新提交'
        },
        {
          returnReson: '收银台不符合要求，请重新上传',
          solution: '收银台照片必须包含收银台卡，二维码，扫码枪，收银台等物体，以示真实交易场景。'
        },
        {
          returnReson: '重新提供三合照',
          solution: '收银台照必须包含真实收银场景。店内照必须体现店内真实消费环境。门店招牌照必须体现门店招牌名称。照片必须为真实拍照，禁止截图，PS，有水印'
        },
        {
          returnReson: '商户名称与门头照不一致',
          solution: '商户名称，必须与门头照（门店招牌照）中一致'
        },
        {
          returnReson: '法人姓名不一致',
          solution: '填写的法人姓名，与营业执照照片中的法人姓名不一致'
        },
        {
          returnReson: '系统判断卡号正确性： 卡号错误',
          solution: '填写的卡号错误，与银行卡照片上的卡号不一致。'
        },
        {
          returnReson: '三合照有水印',
          solution: '收银台照必须包含真实收银场景。店内照必须体现店内真实消费环境。门店招牌照必须体现门店招牌名称。照片必须为真实拍照，禁止截图，PS，有水印'
        },
        {
          returnReson: '营业执照模糊',
          solution: '上传营业执照照片模糊，无法看清有效信息，确认真实有效。请重新补充合规照片后提交。'
        },
        {
          returnReson: '身份证与姓名不一致，身份证为p图',
          solution: '身份证照片显示的姓名，与填写的结算人不是同一个人。身份证为P图。'
        },
        {
          returnReson: '三合照与行业不符',
          solution: '营业执照的经营范围，跟门头照不符合。'
        },
        {
          returnReson: '缺少非法人身份证正面照片/第三方授权函需要法人以及非法人身份证合照',
          solution: '企业类型有营业执照商户，对私结算，结算给非法人时，需要提供非法人授权函。'
        },
        {
          returnReson: '禁止重复进件',
          solution: '同一套商户资料，多次进件，不允许重复进件。备注：如特殊商户需要重复进件，请提前与乐刷运营沟通确认。'
        }
      ]
    }
  },
  watch: {
    visible (value) {
      this.dialogVisible = value
    }
  }
}
</script>

<style scoped>
.dialog-content-view h2 {
  text-align: center;
}
.tip-two-dl dd {
  margin-left: 0;
}
.time {
  text-align: right;
}
</style>
